<template>
  <path d="M11.131,24.1a2.269,2.269,0,0,0,2.262,2.262h9.048A2.269,2.269,0,0,0,24.7,24.1V10.524H11.131Zm2.788-8.052,1.6-1.6,2.4,2.4,2.4-2.4,1.6,1.6-2.4,2.4,2.4,2.4-1.6,1.6-2.4-2.4-2.4,2.4-1.6-1.6,2.4-2.4Zm7.956-8.912L20.744,6H15.089L13.958,7.131H10V9.393H25.833V7.131Z" transform="translate(-10 -6)"/>
</template>
